import { AI_AGENT_EMAIL_DOMAIN, SUPER_ADMIN_EMAIL_DOMAIN } from './Consts'

let aiAgentDomainAllowed = false

/** Dev projects also accept the AI-agent domain. Defaults to off, so production stays strict. */
export function setAiAgentSuperAdminDomainAllowed(allowed: boolean): void {
  aiAgentDomainAllowed = allowed
}

/**
 * Platform operator: the persisted `isSuperAdmin` flag AND a company-domain address. No self-service
 * path sets the flag — only a direct Firestore write or an existing operator through `updateUser`.
 */
export function isPlatformSuperAdmin(user?: { isSuperAdmin?: boolean; email?: string } | null): boolean {
  if (user?.isSuperAdmin !== true) return false
  const email = user.email?.trim().toLowerCase()
  if (!email) return false
  if (email.endsWith(SUPER_ADMIN_EMAIL_DOMAIN)) return true
  return aiAgentDomainAllowed && email.endsWith(AI_AGENT_EMAIL_DOMAIN)
}
